import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RedirectNotFoundResolver implements Resolve<any> {
	resolve(): Observable<string> {
		return of(location.pathname + location.search);
	}
}
